import {createApp} from 'vue';
import AppComponent from '@/App.vue';
import * as Sentry from '@sentry/vue';
import router from '@/router';
import pinia from '@/store';
import 'flatpickr/dist/flatpickr.css';
import 'swiper/css';
import './assets/scss/_flatpickr.scss';
import './assets/scss/_global.scss';
import './assets/scss/_reset.scss';

// pds global style classes
import '@pds/style/classes/_pds-classes.scss';

const app = createApp(AppComponent);

if (import.meta.env.VITE_APP_ENVIRONMENT === 'release') {
    Sentry.init({
        app,
        // The DSN tells the SDK where to send the events.
        dsn: 'https://3acef94b989846e7a7314023d1e65a2b@o371464.ingest.sentry.io/4505559411458048',
        environment: import.meta.env.VITE_APP_ENVIRONMENT,
        integrations: [
            new Sentry.Integrations.Breadcrumbs({console: true}),
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(
                    router,
                    {
                        routeLabel: 'path',
                    },
                ),
                tracePropagationTargets: [
                    /^http:\/\/localhost:\d+\//,
                    /^http:\/\/127.0.0.1:\d+\//,
                ],
            }),
        ],
        tracingOptions: {
            // https://docs.sentry.io/platforms/javascript/guides/vue/features/component-tracking/
            trackComponents: true,
        },

        attachProps: true,

        // This option is required for capturing headers and cookies.
        sendDefaultPii: true,

        // Performance Monitoring
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1, // Capture 100% of the transactions, reduce in production!

        // Session Replay
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    Sentry.configureScope(function (scope) {
        scope.setUser({});
    });
}

app.use(pinia).use(router).mount('#app');
